var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-gray container-fix-padding", attrs: { fluid: "" } },
    [
      _vm.question
        ? _c(
            "div",
            { staticClass: "d-flex" },
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-breadcrumbs", {
                    staticClass: "p-0",
                    attrs: { items: _vm.breadcrumbs },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex flex-wrap" },
        [
          _c(
            "v-col",
            { staticClass: "col-xs-12 col-lg-8", attrs: { lg: "8", xs: "12" } },
            [
              _vm.question
                ? _c(
                    "v-card",
                    {
                      staticClass: "pt-2 px-4 pb-0 mb-4 bg-white",
                      attrs: { outlined: "", tile: "" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex" },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "1" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  class: {
                                    "success dark": _vm.question.voteMark == 1,
                                  },
                                  attrs: { fab: "", small: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.upVote(
                                        _vm.question.voteMark,
                                        _vm.question.id,
                                        "Question"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", { attrs: { dark: "" } }, [
                                    _vm._v("keyboard_arrow_up"),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "vote-value" }, [
                                _vm._v(_vm._s(_vm.question.voteMark)),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  class: {
                                    "success dark": _vm.question.voteMark == -1,
                                  },
                                  attrs: { fab: "", small: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.downVote(
                                        _vm.question.voteMark,
                                        _vm.question.id,
                                        "Question"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", { attrs: { dark: "" } }, [
                                    _vm._v("keyboard_arrow_down"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            { attrs: { cols: "11" } },
                            [
                              !_vm.question.isEditing
                                ? [
                                    _vm.question.questionRelatives.length > 0
                                      ? _c(
                                          "router-link",
                                          {
                                            staticClass: "ms-4",
                                            attrs: {
                                              to:
                                                "/classroom/courses/" +
                                                _vm.course.relativeableId +
                                                "?lesson_id=" +
                                                _vm.lesson.relativeableId,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(_vm.lesson.name) +
                                                "\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "v-card-title",
                                      { staticClass: "pt-0 question-title" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.question.title) +
                                            "\n                "
                                        ),
                                        _vm.question.questionType ==
                                        "private_question"
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "private-question",
                                              },
                                              [_vm._v("（プライベート質問）")]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("v-divider"),
                                    _vm._v(" "),
                                    _c(
                                      "v-card-text",
                                      [
                                        _c("div", {
                                          staticClass: "mb-4 html-body",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.question.renderedBody
                                            ),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "d-flex",
                                            attrs: { dense: "" },
                                          },
                                          _vm._l(
                                            _vm.question.materials,
                                            function (material) {
                                              return _c(
                                                "v-col",
                                                {
                                                  key: material.id,
                                                  staticClass: "attachment-col",
                                                },
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { top: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function (ref) {
                                                              var on = ref.on
                                                              var attrs =
                                                                ref.attrs
                                                              return [
                                                                _c(
                                                                  "v-card",
                                                                  _vm._g(
                                                                    _vm._b(
                                                                      {
                                                                        staticClass:
                                                                          "me-2",
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              $event.preventDefault()
                                                                              return _vm.downloadFile(
                                                                                material.link
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      "v-card",
                                                                      attrs,
                                                                      false
                                                                    ),
                                                                    on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "p-1",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "FileIcon",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                fileName:
                                                                                  material.fileName,
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "px-2 title-truncate",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            material.fileName
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            material.fileName
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.question.user &&
                                        _vm.question.user.id == _vm.user.id
                                          ? _c(
                                              "div",
                                              { staticClass: "d-flex" },
                                              [
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "12" } },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass: "me-2",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.question.isEditing = true
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("編集")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deleteQuestion(
                                                              _vm.question.id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("消去")]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "d-flex" },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "p-0",
                                                attrs: { cols: "12" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "float-right d-flex",
                                                  },
                                                  [
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass: "me-2",
                                                        attrs: { cols: "2" },
                                                      },
                                                      [
                                                        _vm.question.user &&
                                                        _vm.question.user.image
                                                          ? _c("img", {
                                                              staticStyle: {
                                                                width: "40px",
                                                              },
                                                              attrs: {
                                                                src: _vm
                                                                  .question.user
                                                                  .image.url,
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("v-col", [
                                                      _vm.question.user
                                                        ? _c("div", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.question
                                                                  .user.name
                                                              )
                                                            ),
                                                          ])
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "grey--text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.question.createdAt.substring(
                                                                0,
                                                                10
                                                              )
                                                            ) + "に質問しました"
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-divider"),
                                        _vm._v(" "),
                                        _c(
                                          "v-list",
                                          {
                                            attrs: {
                                              "three-line": "",
                                              dense: "",
                                            },
                                          },
                                          _vm._l(
                                            _vm.question.comments,
                                            function (comment) {
                                              return _c("CommentComponent", {
                                                key: comment.id,
                                                staticClass: "px-0",
                                                attrs: {
                                                  id: "comment-" + comment.id,
                                                  comment: comment,
                                                  user: _vm.user,
                                                  deleteComment:
                                                    _vm.deleteComment,
                                                  updateComment:
                                                    _vm.updateComment,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("CommentCreation", {
                                          attrs: {
                                            showCommentForm:
                                              _vm.question.showCommentForm,
                                            createComment: _vm.createComment,
                                            onCancel: function () {
                                              _vm.question.showCommentForm = false
                                            },
                                            onOpen: function () {
                                              _vm.question.showCommentForm = true
                                            },
                                          },
                                          on: {
                                            "update:showCommentForm": function (
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.question,
                                                "showCommentForm",
                                                $event
                                              )
                                            },
                                            "update:show-comment-form":
                                              function ($event) {
                                                return _vm.$set(
                                                  _vm.question,
                                                  "showCommentForm",
                                                  $event
                                                )
                                              },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                : [
                                    _c("Simplemde", {
                                      attrs: { rows: 3, name: "answer-new" },
                                      model: {
                                        value: _vm.question.body,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.question, "body", $$v)
                                        },
                                        expression: "question.body",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "d-flex" },
                                      [
                                        _vm.user &&
                                        _vm.user.hasActiveSubscription
                                          ? _c(
                                              "v-col",
                                              { attrs: { lg: "12" } },
                                              [
                                                _c("v-checkbox", {
                                                  staticClass: "my-0",
                                                  attrs: {
                                                    label:
                                                      "プライベート質問 ＊この質問は一般には公開されません",
                                                    "true-value":
                                                      "private_question",
                                                    "false-value":
                                                      "nomal_question",
                                                    "hide-details": "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.question.questionType,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.question,
                                                        "questionType",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "question.questionType",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { lg: "12" } },
                                          [
                                            _c("v-file-input", {
                                              attrs: {
                                                label: "素材をアップロード",
                                                multiple: "",
                                                "prepend-icon": "mdi-paperclip",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "selection",
                                                    fn: function (ref) {
                                                      var text = ref.text
                                                      return [
                                                        _c(
                                                          "v-chip",
                                                          {
                                                            attrs: {
                                                              small: "",
                                                              label: "",
                                                              color: "primary",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(text) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                3352134976
                                              ),
                                              model: {
                                                value: _vm.question.files,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.question,
                                                    "files",
                                                    $$v
                                                  )
                                                },
                                                expression: "question.files",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "me-2",
                                        attrs: { color: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.updateQuestion(
                                              _vm.question
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("質問を投稿する")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        on: {
                                          click: function ($event) {
                                            _vm.question.isEditing = false
                                          },
                                        },
                                      },
                                      [_vm._v("キャンセル")]
                                    ),
                                  ],
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "h2",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.question && _vm.question.userAnswers.length > 0,
                      expression: "question && question.userAnswers.length > 0",
                    },
                  ],
                  staticClass: "mb-4",
                },
                [_vm._v("アンサー")]
              ),
              _vm._v(" "),
              _vm.question && _vm.question.userAnswers.length > 0
                ? _c(
                    "div",
                    { staticClass: "mb-5 bg-white" },
                    _vm._l(_vm.question.userAnswers, function (answer) {
                      return _c(
                        "v-card",
                        {
                          key: answer.id,
                          staticClass: "pt-2 px-4 pb-0 mb-5",
                          attrs: {
                            outlined: "",
                            tile: "",
                            id: "answer-" + answer.id,
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex" },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "1" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      class:
                                        answer.voteMark == 1
                                          ? "success dark"
                                          : "",
                                      attrs: { fab: "", small: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.upVote(
                                            answer.voteMark,
                                            answer.id,
                                            "Answer"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", { attrs: { dark: "" } }, [
                                        _vm._v("keyboard_arrow_up"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "vote-value" }, [
                                    _vm._v(_vm._s(answer.voteMark)),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      class:
                                        answer.voteMark == -1
                                          ? "success dark"
                                          : "",
                                      attrs: { fab: "", small: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.downVote(
                                            answer.voteMark,
                                            answer.id,
                                            "Answer"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", { attrs: { dark: "" } }, [
                                        _vm._v("keyboard_arrow_down"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "11" } },
                                [
                                  _c(
                                    "v-card-text",
                                    { staticClass: "pt-0" },
                                    [
                                      !answer.isEditing
                                        ? [
                                            _c(
                                              "div",
                                              { staticClass: "d-flex" },
                                              [
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "8" } },
                                                  [
                                                    _c("div", {
                                                      staticClass: "html-body",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          answer.renderedBody
                                                        ),
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                answer.user &&
                                                _vm.question.user.id ==
                                                  _vm.user.id
                                                  ? _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "float-right",
                                                        attrs: { cols: "4" },
                                                      },
                                                      [
                                                        answer.accepted == true
                                                          ? _c(
                                                              "div",
                                                              [
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    attrs: {
                                                                      color:
                                                                        "danger",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.setBestAnswer(
                                                                            answer,
                                                                            "false"
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "ベストアンサーを取り消す"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _c(
                                                              "div",
                                                              [
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    attrs: {
                                                                      color:
                                                                        "primary",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.setBestAnswer(
                                                                            answer,
                                                                            "true"
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "ベストアンサーにする!"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "v-col",
                                                      { attrs: { cols: "2" } },
                                                      [
                                                        answer.accepted == true
                                                          ? _c(
                                                              "div",
                                                              [
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    attrs: {
                                                                      color:
                                                                        "success ",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "ベストアンサー"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "d-flex",
                                                attrs: { dense: "" },
                                              },
                                              _vm._l(
                                                answer.materials,
                                                function (material) {
                                                  return _c(
                                                    "v-col",
                                                    {
                                                      key: material.id,
                                                      staticClass:
                                                        "attachment-col",
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: { top: "" },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function (
                                                                  ref
                                                                ) {
                                                                  var on =
                                                                    ref.on
                                                                  var attrs =
                                                                    ref.attrs
                                                                  return [
                                                                    _c(
                                                                      "v-card",
                                                                      _vm._g(
                                                                        _vm._b(
                                                                          {
                                                                            staticClass:
                                                                              "me-2",
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  $event.preventDefault()
                                                                                  return _vm.downloadFile(
                                                                                    material.link
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          "v-card",
                                                                          attrs,
                                                                          false
                                                                        ),
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "p-1",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "FileIcon",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    fileName:
                                                                                      material.fileName,
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "px-2 title-truncate",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                material.fileName
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            true
                                                          ),
                                                        },
                                                        [
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                material.fileName
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                            _vm._v(" "),
                                            answer.user &&
                                            answer.user.id == _vm.user.id
                                              ? _c(
                                                  "div",
                                                  { staticClass: "d-flex" },
                                                  [
                                                    _c(
                                                      "v-col",
                                                      { attrs: { cols: "12" } },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass: "me-2",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                answer.isEditing = true
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("編集")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "a",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.deleteAnswer(
                                                                  answer.id
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("消去")]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        : [
                                            _c("Simplemde", {
                                              attrs: {
                                                rows: 3,
                                                name: "answer-new",
                                              },
                                              model: {
                                                value: answer.body,
                                                callback: function ($$v) {
                                                  _vm.$set(answer, "body", $$v)
                                                },
                                                expression: "answer.body",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "d-flex" },
                                              [
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "12" } },
                                                  [
                                                    _c("v-file-input", {
                                                      attrs: {
                                                        label:
                                                          "素材をアップロード",
                                                        multiple: "",
                                                        "prepend-icon":
                                                          "mdi-paperclip",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "selection",
                                                            fn: function (ref) {
                                                              var text =
                                                                ref.text
                                                              return [
                                                                _c(
                                                                  "v-chip",
                                                                  {
                                                                    attrs: {
                                                                      small: "",
                                                                      label: "",
                                                                      color:
                                                                        "primary",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          text
                                                                        ) +
                                                                        "\n                          "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                      model: {
                                                        value: answer.files,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            answer,
                                                            "files",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "answer.files",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "me-2",
                                                attrs: { color: "primary" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.updateAnswer(
                                                      answer
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("アンサーを送信する")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-btn",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    answer.isEditing = false
                                                  },
                                                },
                                              },
                                              [_vm._v("キャンセル")]
                                            ),
                                          ],
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "d-flex" },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "p-0",
                                              attrs: { cols: "12" },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "float-right d-flex",
                                                },
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "me-2",
                                                      attrs: { cols: "2" },
                                                    },
                                                    [
                                                      answer.user &&
                                                      answer.user.image
                                                        ? _c("img", {
                                                            staticStyle: {
                                                              width: "40px",
                                                            },
                                                            attrs: {
                                                              src: answer.user
                                                                .image.url,
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("v-col", [
                                                    answer.user
                                                      ? _c("div", [
                                                          _vm._v(
                                                            _vm._s(
                                                              answer.user.name
                                                            )
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "grey--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            answer.createdAt.substring(
                                                              0,
                                                              10
                                                            )
                                                          ) +
                                                            "にアンサーしました"
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-divider"),
                                      _vm._v(" "),
                                      _c(
                                        "v-list",
                                        { attrs: { dense: "" } },
                                        _vm._l(
                                          answer.comments,
                                          function (comment) {
                                            return _c("CommentComponent", {
                                              key: comment.id,
                                              staticClass: "px-0",
                                              attrs: {
                                                id: "comment-" + comment.id,
                                                comment: comment,
                                                user: _vm.user,
                                                deleteComment:
                                                  _vm.deleteComment,
                                                updateComment:
                                                  _vm.updateComment,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("CommentCreation", {
                                        attrs: {
                                          showCommentForm:
                                            answer.showCommentForm,
                                          onCancel: function () {
                                            answer.showCommentForm = false
                                          },
                                          onOpen: function () {
                                            answer.showCommentForm = true
                                          },
                                          createComment: function (newComment) {
                                            _vm.createAnswerComment(
                                              newComment,
                                              answer
                                            )
                                          },
                                        },
                                        on: {
                                          "update:showCommentForm": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              answer,
                                              "showCommentForm",
                                              $event
                                            )
                                          },
                                          "update:show-comment-form": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              answer,
                                              "showCommentForm",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.question
                ? _c(
                    "v-card",
                    {
                      staticClass: "p-4 bg-white",
                      attrs: { outlined: "", tile: "" },
                    },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "headline px-0 pt-0" },
                        [_vm._v("アンサーを投稿")]
                      ),
                      _vm._v(" "),
                      _c("Simplemde", {
                        attrs: { rows: 3, name: "answer-body" },
                        model: {
                          value: _vm.newAnswer,
                          callback: function ($$v) {
                            _vm.newAnswer = $$v
                          },
                          expression: "newAnswer",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex" },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-file-input", {
                                attrs: {
                                  label: "素材をアップロード",
                                  multiple: "",
                                  "prepend-icon": "mdi-paperclip",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function (ref) {
                                        var text = ref.text
                                        return [
                                          _c(
                                            "v-chip",
                                            {
                                              attrs: {
                                                small: "",
                                                label: "",
                                                color: "primary",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(text) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3745244224
                                ),
                                model: {
                                  value: _vm.answerFiles,
                                  callback: function ($$v) {
                                    _vm.answerFiles = $$v
                                  },
                                  expression: "answerFiles",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "me-2",
                          attrs: { color: "primary" },
                          on: { click: _vm.createAnswer },
                        },
                        [_vm._v("アンサーを送信する")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "bg-white mt-3 me-3 mb-3",
              class: { "ms-3": _vm.mobile },
              attrs: { lg: "3", xs: "12" },
            },
            [_c("QuestionSidebar")],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ConfirmDialog", { ref: "confirm" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }